<script setup lang="ts">
    // @ts-ignore
    import i18n from '@/localization/i18n';
    import { computed, onBeforeUnmount, onMounted,ref, } from 'vue'
    import { Carousel, Slide} from 'vue3-carousel'


    // Local variables
    const t = i18n.global.t

    // @ts-ignore
    const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

    // Refs
    const isViewingItem = ref(false);
    let activeSlide  = ref(0)
    const visibleRef = ref(false)
    const slideItemsPerPage = ref(5)
    const indexRef = ref(1)
    const slideItemsNumber = 21

    // Lifecycle hooks
    onMounted(() => {
        setCapturesItemPerPage()
        window.addEventListener('resize', handleResize);
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize);
    });

    const totalPages = computed(() => Math.ceil(slideItemsNumber / slideItemsPerPage.value));
    const currentPage = computed(() => Math.floor(activeSlide.value / slideItemsPerPage.value) + 1);

    const changePage = (page:number) => {
        activeSlide.value = (page - 1) * slideItemsPerPage.value;
    };

    const imageUrls = computed(() =>
      Array.from({ length: slideItemsNumber }, (_, i) => {
        return `${VITE_ASSET_URL}assets/public/assets/img/screenshot/img-${
          i + 1
        }.webp`;
      })
    );

     const setCapturesItemPerPage = () =>{
      slideItemsPerPage.value = window.innerWidth <= 950 ? 3 : 5
    }

    const handleResize = () => {
      setCapturesItemPerPage()
    };

    const onHide = () => {
      visibleRef.value = false
      isViewingItem.value = false;
    }

    const showImg = (index: number) => {
      indexRef.value = index - 1
      visibleRef.value = true
      isViewingItem.value = true;
    }

  const screenshotsDescription = [
    "Accès sécurisé", "Profil personnalisé", "Accueil ergonomique", "Demandes / annonces client", "Annonce client et mise en contact",
    "Bibliothèque de devis prédéfinis", "Création de modèles de devis", "Chiffrage facile et rapide", "Gestion des devis client", "Calculs automatisés et vérifiés",
    "Devis avec prise de photos", "Signature électronique certifiée", "Suivi de prestations", "Photos de chantier partagées", "Gestion de prestation",
    "Gestion de factures, acomptes et avoirs", "Factures générées automatiquement", "Export PDF des documents", "Messagerie intégrée", "Notifications en temps réel",
    "Export comptable normalisé"
  ]
</script>

<template>
    <!-- Awesome Screens Section Start -->
    <div id="screenshots" class="screens-shot py-5" style="padding-bottom: 5px !important;">
      <div class="container">
        <nav class="not-visible-content">
          <a href="/pro/">Fonctionnalités</a> 
        </nav>
        <h2  class="h-style h2-style use-poppins text-center mb-0 fw-semibold">
          {{ t("w_txt_home_prouserOfficeInPocket") }}
        </h2>
        <div class="row">
            <Carousel :autoplay="isViewingItem ? 0 : 5000" :wrap-around="true" :itemsToShow="slideItemsPerPage" 
                :transition="1000" class="custom-carousel" v-model="activeSlide" style="margin-top: 0px !important;">
                <Slide v-for="slide in slideItemsNumber"  :key="slide">
                    <div class="carousel__item">
                        <div class="item">
                            <div class="screenshot-thumb">
                                <a href="javascript:void(0)" @click="showImg(slide)" data-toggle="lightbox" data-gallery="example-gallery">
                                  <img @click="() => showImg(slide)"
                                  class="img-fluid img-rounded"
                                  :src="VITE_ASSET_URL + `assets/public/assets/img/screenshot/img-${slide}.webp`"/>
                                </a>
                            </div>
                            <div class="description mb-4">
                              <h3 class="description-text">
                                {{ screenshotsDescription[slide - 1] }}
                              </h3>
                            </div>
                        </div>
                    </div>
                </Slide>
                <template #addons>
                    <div class="custom-pagination">
                        <div v-for="(index) in totalPages" :key="index" class="pagination-dot" :class="{ active: index === currentPage }" @click="changePage(index)"></div>
                    </div>
                </template>
            </Carousel>

            <vue-easy-lightbox 
              :visible="visibleRef" 
              :imgs="imageUrls"
              :index="indexRef" @hide="onHide">
            </vue-easy-lightbox>
        </div>
      </div>
    </div>
    <!-- Awesome Screens Section End -->

</template>

<style scoped>
.carousel__slide{
  align-items: start !important;
}
.custom-pagination {
  display: flex;
  justify-content: center;
}

.pagination-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 5px;
  background: #EBEAEAFF; 
}

.pagination-dot.active {
  background: #49AFDA;
}

.img-rounded {
  border-radius: 10px !important;
  box-shadow: 4px 5px 5px gray !important;
}

.custom-carousel {
  padding-top: 35px;
  padding-bottom: 40px;
  padding-left: 0px !important;
  padding-right: 0px;
}

.description-text{
  font-size: 14px;
  color: #82868f;
  font-weight:normal;
  vertical-align: top;
}

/* Medium devices (md) - 768px and up */
@media (min-width: 768px) {
    /* Styles for medium screens */
  .img-rounded {
    border-radius: 15px !important;
  }
}.vel-modal {
  top: 20px !important;
}

</style>